<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Announcement</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the title of the Announcement?
              </div>
              <v-text-field
                v-model="data.title"
                hide-details
                dense
                outlined
                placeholder="Announcement Title"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Subtitle</div>
              <v-text-field
                v-model="data.subtitle"
                hide-details
                dense
                outlined
                placeholder="Subtitle"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex xs6 class="mr-1">
              <div class="subtitle-2 mb-1">Placement</div>
              <v-text-field
                v-model="data.placement"
                hide-details
                dense
                outlined
                placeholder="Ex: mapFeed"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="ml-1">
              <div class="subtitle-2 mb-1">State</div>
              <v-select
                v-model="state"
                :items="stateItems"
                hide-details
                dense
                outlined
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Expires At</div>
              <!-- <v-text-field
                v-model="expiresAtDateString"
                readonly
                hide-details
                dense
                outlined
                placeholder="Expire Date"
                @click="expiryDateDialog = true"
              ></v-text-field> -->
              <v-text-field
                v-model="expiresAtDateString"
                readonly
                hide-details
                dense
                outlined
                placeholder="Expire Date"
                @click="openExpiryDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="selectedRegion" class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <!-- <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    readonly
                    outlined
                    dense
                    hide-details
                    v-model="selectedRegion.name"
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-text-field>
                </template>

                <v-list dense>
                  <v-list-item
                    @click="selectRegion(region)"
                    v-for="(region, i) in regions"
                    :key="i"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ region.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu> -->
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Card Options</div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Text Color</div>
              <v-text-field
                v-model="data.textColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #FFCDD2"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Background Color</div>
              <v-text-field
                v-model="data.backgroundColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #FFCDD2"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Icon Name</div>
              <v-text-field
                v-model="data.icon.name"
                hide-details
                dense
                outlined
                placeholder="Ex: gift"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Icon Type</div>
              <v-text-field
                v-model="data.icon.type"
                hide-details
                dense
                outlined
                placeholder="Ex: MaterialCommunityIcons"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">
              Navigation Button Options
            </div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Action</div>
              <v-text-field
                v-model="data.navigate.action"
                hide-details
                dense
                outlined
                placeholder="Ex: Redeem"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">To</div>
              <v-text-field
                v-model="data.navigate.to"
                hide-details
                dense
                outlined
                placeholder="Ex: Vibez"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Text Color</div>
              <v-text-field
                v-model="data.navigate.textColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #ffcc00"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Background Color</div>
              <v-text-field
                v-model="data.navigate.backgroundColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #ffcc00"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <!-- <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Latitude</div>
              <v-text-field
                v-model="latitude"
                hide-details
                dense
                outlined
                placeholder="Latitude"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Longitude</div>
              <v-text-field
                v-model="longitude"
                hide-details
                dense
                outlined
                placeholder="Logitude"
              ></v-text-field>
            </v-flex>
          </v-layout> -->
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-dialog v-model="scheduleDateDialog" width="300">
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex> Schedule Date </v-flex>
            <v-flex text-right>
              <v-btn icon @click="scheduleDateDialog = false">
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-date-picker v-model="scheduledAtDateField" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="expiryDateDialog" width="300">
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex> Expire Date </v-flex>
            <v-flex text-right>
              <v-btn icon @click="expiryDateDialog = false">
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-date-picker v-model="expireAtDateField" />
      </v-card>
    </v-dialog> -->
    <time-and-date-select-dialog
      @onDateSelected="onExpiryDateSelected"
      ref="ExpiryTimeAndDateDialogRef"
    />
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import firebase from "firebase";
import { auth } from "@/plugins/firebase";
import moment from "moment";
import TimeAndDateSelectDialog from "./TimeAndDateSelectDialog.vue";
export default {
  components: { TimeAndDateSelectDialog },
  props: {
    announcementDetails: {
      type: Object,
      default: function () {
        return {};
      },
    },
    selectedRegion: {
      type: Object,
      default: function () {
        return {};
      },
    },
    collection: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      dialog: false,
      dialogAction: "",
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: null,
      expireAtDateField: null,
      scheduledAt: "",
      id: "",
      state: "",
      region: {},
      stateItems: ["scheduled", "active", "cancelled", "updated", "deleted"],
      data: {
        backgroundColor: "",
        expiresAt: "",
        icon: {
          name: "",
          type: "",
        },
        location: {
          latitude: "",
          longitude: "",
        },
        navigate: {
          action: "",
          backgroundColor: "",
          textColor: "",
          to: "",
        },
        placement: "",

        subtitle: "",
        textColor: "",
        title: "",
      },
    };
  },
  computed: {
    ...mapState("$_home", ["regions"]),
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    expiresAtDateString() {
      if (this.expireAtDateField) {
        return this.iMoment(this.expireAtDateField);
      } else {
        return this.data.expiresAt;
      }
    },

    // selectedRegion() {
    //   var region = {};
    //   region = this.search(
    //     this.data.location.latitude,
    //     this.data.location.longitude,
    //     this.regions
    //   );
    //   console.log("region: ", region);
    //   return region;
    // },
    changeFieldsCopy() {
      return {
        scheduledAt: this.scheduledAtDateField
          ? this.iMoment(this.scheduledAtDateField)
          : this.scheduledAt,
        type: "announcement",
        region: this.region,
        state: "scheduled",
        createdBy: auth.currentUser.uid,
        data: {
          backgroundColor: this.data.backgroundColor,
          expiresAt: this.expireAtDateField
            ? this.iMoment(this.expireAtDateField)
            : this.data.expiresAt,
          icon: {
            name: this.data.icon.name,
            type: this.data.icon.type,
          },
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.region.latitude),
            parseFloat(this.region.longitude)
          ),
          navigate: {
            action: this.data.navigate.action,
            backgroundColor: this.data.navigate.backgroundColor,
            textColor: this.data.navigate.textColor,
            to: this.data.navigate.to,
          },
          placement: this.data.placement,

          subtitle: this.data.subtitle,
          textColor: this.data.textColor,
          title: this.data.title,
        },
      };
    },

    changeFields() {
      return {
        id: this.id,
        scheduledAt: this.scheduledAtDateField
          ? this.iMoment(this.scheduledAtDateField)
          : this.scheduledAt,
        type: "announcement",
        region: this.region,
        state: this.state,
        editedBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        data: {
          backgroundColor: this.data.backgroundColor,
          expiresAt: this.expireAtDateField
            ? this.iMoment(this.expireAtDateField)
            : this.data.expiresAt,
          icon: {
            name: this.data.icon.name,
            type: this.data.icon.type,
          },
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.region.latitude),
            parseFloat(this.region.longitude)
          ),
          navigate: {
            action: this.data.navigate.action,
            backgroundColor: this.data.navigate.backgroundColor,
            textColor: this.data.navigate.textColor,
            to: this.data.navigate.to,
          },
          placement: this.data.placement,

          subtitle: this.data.subtitle,
          textColor: this.data.textColor,
          title: this.data.title,
        },
      };
    },
  },
  mounted() {
    this.getRegions({ collection: "regions", mutation: "updateRegions" });
  },
  methods: {
    ...mapActions({
      updateAnnouncement: "$_content/updateContent",
      createNewAnnouncement: "$_content/createNewContent",
      getRegions: "$_home/getContent",
      getAnnouncements: "$_content/getContent",
      getAnnouncementsByRegion: "$_content/getContentByRegion",
    }),
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(this.data.expiresAt);
    },
    onExpiryDateSelected(dateTime) {
      // console.log("Expiry Selected Date and Time: ", dateTime);
      this.expireAtDateField = dateTime;
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(this.scheduledAt);
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog(announcementDetails, action) {
      this.dialog = !this.dialog;

      // console.log("Announcement Details: ", announcementDetails);
      if (this.dialog) {
        this.dialogAction = action;
        this.scheduledAtDateField = announcementDetails.scheduledAt
          ? announcementDetails.scheduledAt.seconds * 1000
          : "";
        // this.expireAtDateField =
        //   announcementDetails.data.expiresAt.seconds * 1000;
        this.scheduledAt = this.iMoment(
          announcementDetails.scheduledAt.seconds * 1000
        );
        this.region = announcementDetails.region;
        this.state = announcementDetails.state;
        this.data = {
          backgroundColor: announcementDetails.data.backgroundColor,
          expiresAt: this.iMoment(
            announcementDetails.data.expiresAt.seconds * 1000
          ),
          icon: {
            name: announcementDetails.data.icon.name,
            type: announcementDetails.data.icon.type,
          },
          location: {
            latitude: announcementDetails.data.location.latitude,
            longitude: announcementDetails.data.location.longitude,
          },
          navigate: {
            action: announcementDetails.data.navigate.action,
            backgroundColor: announcementDetails.data.navigate.backgroundColor,
            textColor: announcementDetails.data.navigate.textColor,
            to: announcementDetails.data.navigate.to,
          },
          placement: announcementDetails.data.placement,
          subtitle: announcementDetails.data.subtitle,
          textColor: announcementDetails.data.textColor,
          title: announcementDetails.data.title,
        };
        // console.log("Expiry: ", announcementDetails.data.expiresAt.seconds);
        // if (announcementDetails.data.expiresAt.seconds) {
        //   this.data.expiresAt = this.iMoment(
        //     announcementDetails.data.expiresAt.seconds * 1000
        //   );
        // }

        this.id = announcementDetails.id;

        // console.log("Data: ", this.data);
        // console.log(this.data.expiresAt);
        // console.log("Expiry: ", announcementDetails.data.expiresAt);
      }
    },
    cancel() {
      this.scheduledAtDateField = "";
      this.expireAtDateField = "";
      this.scheduledAt = "";
      this.state = "";
      this.region = {};
      this.data = {
        backgroundColor: "",
        expiresAt: "",

        icon: {
          name: "",
          type: "",
        },
        location: {
          latitude: "",
          longitude: "",
        },
        navigate: {
          action: "",
          backgroundColor: "",
          textColor: "",
          to: "",
        },
        placement: "",

        subtitle: "",
        textColor: "",
        title: "",
      };
      console.log(this.data);
      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      console.log(this.dialogAction);
      if (this.dialogAction === "copy") {
        this.createNewAnnouncement({
          details: this.changeFieldsCopy,
          collection: this.collection,
          type: "Announcement",
        }).then(() => {
          this.dialogAction = "";
          this.dialog = false;
          this.getAnnouncementsByRegion({
            type: "announcement",
            collection: this.collection,
            mutation: "updateAnnouncements",
            region: this.selectedRegion,
          });
        });
      } else {
        this.updateAnnouncement({
          details: this.changeFields,
          collection: this.collection,
          type: "Announcement",
        }).then(() => {
          this.dialog = false;
          this.getAnnouncementsByRegion({
            type: "announcement",
            collection: this.collection,
            mutation: "updateAnnouncements",
            region: this.selectedRegion,
          });
        });
      }
    },
  },
};
</script>

<style>
</style>

          